import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';

import strings from './strings.js'
strings.setLanguage((navigator.language && navigator.language.split('-')[0]) || 'fr');

const Program = () => (
  <div className="centered-body">
    <h2>{strings.program}</h2>
    <Grid>

      <Row>
        <Col xs={12} md={6} mdOffset={3}>
          <div className="program">
            <div className="program-day">
              <div className="program-day-h1">{strings.date1}</div>
              <div className="program-day-p">
                <div className="program-day-event">
                  <div className="program-day-hour -bold">{strings.t1}</div>
                  <div className="program-day-content">{strings.formatString(strings.a1, <span role="img" aria-label="a1">👰🤵</span>)}</div>
                </div>
                <div className="program-day-event">
                <div className="program-day-hour">{strings.formatString(strings.a2, <span role="img" aria-label="a1">🥃🥨</span>)}</div>
                  <div className="program-day-content -bold">{strings.t2}</div>
                </div>
                <div className="program-day-event">
                  <div className="program-day-hour -bold">{strings.t3}</div>
                  <div className="program-day-content">{strings.formatString(strings.a3, <span role="img" aria-label="a1">🍷🍖</span>)}</div>
                </div>
                <div className="program-day-event">
                  <div className="program-day-hour">{strings.formatString(strings.a4, <span role="img" aria-label="a1">💃🕺</span>)}</div>
                  <div className="program-day-content -bold">{strings.t4}</div>
                </div>
                <div className="program-day-event">
                  <div className="program-day-hour -bold">{strings.t5}</div>
                  <div className="program-day-content last">{strings.formatString(strings.a5, <span role="img" aria-label="a1">🎉🛌</span>)}</div>
                </div>
              </div>
              <div className="program-day-h1">{strings.date2}</div>
              <div className="program-day-p">
                <div className="program-day-event">
                  <div className="program-day-hour -bold">{strings.t6}</div>
                  <div className="program-day-content">{strings.formatString(strings.a6, <span role="img" aria-label="a1">🥐🥓</span>, <a href="https://www.google.com/maps/place/Preserve/@38.5211074,-121.9707885,17z/data=!4m12!1m6!3m5!1s0x8084df8b145783b5:0x7b724376767368ec!2sPreserve!8m2!3d38.5211074!4d-121.9685998!3m4!1s0x8084df8b145783b5:0x7b724376767368ec!8m2!3d38.5211074!4d-121.9685998" target="_blank" rel="noopener noreferrer">{strings.preserve}</a>)}</div>
                </div>
                <div className="program-day-event">
                  <div className="program-day-hour">{strings.formatString(strings.a7, <span role="img" aria-label="a1">️🌊⛰</span>)}</div>
                  <div className="program-day-content -bold">{strings.t7}</div>
                </div>
                <div className="program-day-event">
                  <div className="program-day-hour -bold">{strings.t8}</div>
                  <div className="program-day-content last">{strings.formatString(strings.a8, <span role="img" aria-label="a1">🥗🥂</span>, <a href="https://www.google.com/maps/place/2055+Oak+St,+San+Francisco,+CA+94117/@37.7709191,-122.455388,17z/data=!3m1!4b1!4m5!3m4!1s0x80858751e4bdda37:0x992a0826fe6ac6ea!8m2!3d37.7709191!4d-122.4531993" target="_blank" rel="noopener noreferrer">{strings.home}</a>)}</div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  </div>
)

const Home = () => (
  <div className="body">
    <div className="when">
      <h2>{strings.when}</h2>
      <p>
        {strings.when1}<br/>
        {strings.when2}<br/>
        {strings.when3}
      </p>
    </div>
    <div className="separator"></div>
    <div className="where">
      <h2>{strings.where}</h2>
      <p>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/maps/dir/''/park+winters/@38.6355024,-122.0621793,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x8084dd62863323ab:0x73b08ffc3fac394!2m2!1d-121.9921393!2d38.6355233">{strings.where1}</a><br/>
        {strings.where2}<br/>
        {strings.where3}
      </p>
    </div>
  </div>
)

const Hosting = () => (
  <div className="centered-body">
    <h2>{strings.hosting}</h2>
    <Grid>

      <Row>
        <Col xs={12} md={10} mdOffset={1}>
          <h3 className="for-hotels">{strings.reco}</h3>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={7} mdOffset={1}>
          <a className="hosting" rel="noopener noreferrer" target="_blank" href="https://www.marriott.com/hotels/travel/sacva-courtyard-vacaville/"><div className="hotels our-pick">
            <div>Courtyard Marriott Vacaville</div>
          </div></a>
        </Col>
        <Col xs={12} md={3}>
          <div className="hotels-note">
            <p>{strings.formatString(strings.hotel, <a rel="noopener noreferrer" target="_blank" href="https://www.marriott.com/hotels/travel/sacva-courtyard-vacaville/">{strings.courtyard}</a>)}</p>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={10} mdOffset={1}>
          <h3 className="for-hotels">{strings.options}</h3>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={5} mdOffset={1}>
          <a className="hosting" rel="noopener noreferrer" target="_blank" href="http://www.hallmarkinn.com/"><div className="hotels motel">
            <div>Hallmark Inn</div>
          </div></a>
        </Col>
        <Col xs={12} md={5}>
          <a className="hosting" rel="noopener noreferrer" target="_blank" href="https://www.airbnb.com/s/Winters--CA--United-States/homes"><div className="hotels airbnb">
            <div>Airbnb</div>
          </div></a>
        </Col>        
      </Row>

    </Grid>
  </div>
)

const Travel = () => (
  <div className="centered-body travel">
    <h2>{strings.travel}</h2>
    <Grid>
      <Row>
        <Col xs={12} md={12}>
          <h3 className="first">{strings.region}</h3>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://us.frenchbee.com/en"><div className="planes frenchbee">
            <div>{strings.frenchbee}</div>
          </div></a>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://www.norwegian.com/us"><div className="planes norwegian">
            <div>{strings.norwegian}</div>
          </div></a>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://www.google.com/flights"><div className="planes google">
            <div>{strings.flights}</div>
          </div></a>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={12}>
          <h3>{strings.winters}</h3>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://www.rentalcars.com/"><div className="planes rentalcars">
            <div>{strings.rentalcars}</div>
          </div></a>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://turo.com/"><div className="planes turo">
            <div>{strings.turo}</div>
          </div></a>
        </Col>
        <Col xs={12} md={4}>
          <a><div className="planes ratp">
            <div>{strings.ratp}</div>
          </div></a>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={12}>
          <h3>{strings.quitter}</h3>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://www.fivestarls.com/fleet.php"><div className="planes fivestarlimo">
            <div>{strings.fivestarlimo}</div>
          </div></a>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="https://apilimos.com/fleet/e-350-passenger-vans/"><div className="planes apilimos">
            <div>{strings.apilimos}</div>
          </div></a>
        </Col>
        <Col xs={12} md={4}>
          <a rel="noopener noreferrer" target="_blank" href="http://vacavillecheckercab.com/"><div className="planes checker">
            <div>{strings.checker}</div>
          </div></a>
        </Col>
      </Row>

    </Grid>
  </div>
)

const FAQ = () => (
  <div className="centered-body">
    <h2>{strings.faq}</h2>
    <Grid>
      <Row>
        <Col xs={12} md={6} mdOffset={3}>
          {Array.apply(null, {length: 12}).map(Number.call, n => 1 + Number(n)).map(id => (
            <div className="question" key={`q${id}`}>
              <h3>{strings[`q${id}`]}</h3>
              <p>{strings.formatString(strings[`q${id}r`], {
                preserve: <a href="https://www.yelp.com/biz/preserve-winters-2?osq=Fun+Things+To+Do" target="_blank" rel="noopener noreferrer">{strings.preserve}</a>,
                stanyan: <a href="http://www.stanyanpark.com/" target="_blank" rel="noopener noreferrer">{strings.stanyan}</a>
              })}</p>
            </div>
          ))}          
        </Col>
      </Row>
    </Grid>
  </div>
)

const Contact = () => (
  <div className="centered-body">
    <h2>{strings.contact}</h2>
    <p>{strings.contactus} <a href="mailto:mariage@ma26ou.com">mariage@ma26ou.com</a>.</p>
  </div>
)

const Jumbotron = ({ match }) => (
  <div>
    <div className={`jumbotron hero${match.params.active ? ' hidden' : ''}`}>
      <div className="container">
        <div className="hero-text">
          <h1>{strings.ma26ou}</h1>
          <h2>{strings.date}</h2>
          <h2>{strings.location}</h2>
        </div>
      </div>
    </div>
    <div className={`jumbotron hero navigate${match.params.active ? '' : ' hidden'}`}>
      <div className="container">
        <div className="hero-text">
          <h1>{strings.ma26ou}</h1>
        </div>
      </div>
    </div>
  </div>
)

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: (navigator.language && navigator.language.split('-')[0]) || 'fr'};
  }

  switchTo(lang) {
    strings.setLanguage(lang);
    this.setState({lang: lang});
  };


  render() {
  return <Router>
    <div>

      <nav className="navbar navbar-default navbar-static-top">
        <div className="container">

          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
              <span className="sr-only">Toggle navigation</span>
              <span className="menu-bar">MENU</span>
            </button>
            <Link to="/" className="navbar-brand" href="/"><span className="two">ma2</span><span className="six">6ou</span></Link>
          </div>


          <div className="collapse navbar-collapse" id="navbar-collapse">
            <ul className="nav navbar-nav">
              <li><Link to="/program">{strings.program}</Link></li>
              <li><Link to="/hosting">{strings.hosting}</Link></li>
              <li><Link to="/travel">{strings.travel}</Link></li>
              <li><Link to="/faq">{strings.faq}</Link></li>
              <li><Link to="/contact">{strings.contact}</Link></li>
              <li><a className="rsvp" target="_blank" rel="noreferrer noopener" href="https://ma26ou.rsvpify.com">{strings.rsvp}</a></li>
              <li><a className="rsvp" target="_blank" rel="noreferrer noopener" href="https://www.our-wedding-registry.com/gantzer.collin.22914">{strings.registry}</a></li>
            </ul>

            <ul className="nav navbar-nav navbar-right">
              <li><a className="picklang"><button onClick={() => this.switchTo('fr')}><span className={`lang${this.state.lang === 'fr' ? ' curlang' : ''}`} role="img" aria-label="french flag">🇫🇷</span></button> | <button onClick={() => this.switchTo('en')}><span className={`lang${this.state.lang === 'en' ?  ' curlang' : ''}`} role="img" aria-label="USA flag">🇺🇸</span></button></a></li>
            </ul>
          </div>



        </div>
      </nav>

      <Route path="/:active?" component={Jumbotron} />
     
      <Route path="/" exact component={Home}/>
      <Route path="/program" component={Program}/>
      <Route path="/hosting" component={Hosting}/>
      <Route path="/travel" component={Travel}/>
      <Route path="/faq" component={FAQ}/>
      <Route path="/contact" component={Contact}/>
    </div>
  </Router>
  }
}
export default App



// WEBPACK FOOTER //
// ./src/App.js